export default function confirm(cb, message) {
  const confirmationMessage =
    message || "Are you sure you want to complete this action?";

  if (window.confirm(confirmationMessage)) {
    cb();
  }
}
